import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSettingsGear = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m19.418 6.847.754 1.306a2.093 2.093 0 0 1-.767 2.858c-.76.44-.76 1.538 0 1.977a2.093 2.093 0 0 1 .767 2.858l-.754 1.307a2.093 2.093 0 0 1-2.86.766 1.14 1.14 0 0 0-1.71.987A2.094 2.094 0 0 1 12.755 21h-1.508a2.094 2.094 0 0 1-2.093-2.094c0-.877-.95-1.426-1.712-.987a2.09 2.09 0 0 1-2.858-.766l-.754-1.307c-.578-1-.236-2.28.765-2.858a1.14 1.14 0 0 0 0-1.976 2.09 2.09 0 0 1-.765-2.86l.754-1.305a2.09 2.09 0 0 1 2.858-.767 1.14 1.14 0 0 0 1.712-.987C9.154 3.937 10.09 3 11.247 3h1.508c1.156 0 2.093.937 2.093 2.093a1.14 1.14 0 0 0 1.711.987c1-.578 2.28-.234 2.859.767"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.213 12a3.212 3.212 0 1 0-6.425-.001 3.212 3.212 0 0 0 6.425 0"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSettingsGear);
export default ForwardRef;
